<template>
  <v-modal
    id="supplier-resource-media-edit"
    :is-double-modal="true"
    size="lg"
    @closed="$emit('closed')"
  >
    <modal-header>
      <modal-title>
        {{ $t('supplier.resource.media') }}
      </modal-title>
    </modal-header>

    <modal-body>
      <div class="supplier-resource-media-container">
        <div class="mb-16">
          <v-uploader
            ref="uploader"
            :afterUpload="onChange"
            route-prefix="api/s3"
            @removed="onChange"
          />
        </div>

        <div v-if="media.length > 0" class="d-flex justify-content-end">
          <v-button
            class="btn-icon w-fit"
            size="sm"
            variant="primary"
            @click="saveResourceMedia"
          >
            {{ $t('general.button.save') }}
            <v-icon icon="arrow-right" size="sm" space="ms-12"/>
          </v-button>
        </div>
      </div>
    </modal-body>
  </v-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import VModal from '@/components/vendor/basic/modal/VModal.vue';
import ModalHeader from '@/components/vendor/basic/modal/ModalHeader.vue';
import ModalTitle from '@/components/vendor/basic/modal/ModalTitle.vue';
import ModalBody from '@/components/vendor/basic/modal/ModalBody.vue';
import useConcepts from '@/helpers/Concepts';
import useModalUtils from '@/helpers/ModalUtils';
import api from '@/api';
import VUploader from '@/components/vendor/upload/VUploader.vue';
import VButton from '@/components/vendor/basic/button/VButton.vue';
import VIcon from '@/components/vendor/basic/icon/VIcon.vue';
import SupplierResource from '@/api/objects/SupplierResource';

export default defineComponent({
  name: 'TheSupplierResourceDetailsMediaModal',
  components: {
    VUploader,
    ModalBody,
    ModalTitle,
    ModalHeader,
    VModal,
    VButton,
    VIcon,
  },
  emits: ['closed', 'emitReloadResource'],
  props: {
    resource: {
      type: SupplierResource,
      required: true,
    },
  },
  setup() {
    return {
      ...useConcepts(),
      ...useModalUtils(),
    };
  },
  data() {
    return {
      media: [] as any,
    };
  },
  computed: {
    mediaUuids() {
      return this.media.map((media: any) => ({
        uuid: media.attributes.uuid,
        name: media.attributes.name,
      }));
    },
  },
  methods: {
    onChange() {
      const { uploader }: any = this.$refs;
      if (!!uploader) {
        this.media = uploader.mediaLibrary.state.media;
      }
    },
    async saveResourceMedia() {
      try {
        const data: any = {
          name: this.resource.name,
          type: this.resource.type,
          description: this.resource.description,
          cancellation_policy: this.resource.cancellationPolicy,
          amenities: JSON.parse(this.resource.amenities),
          images: this.mediaUuids,
        };

        await api.supplierResource.update(this.resource.id, data);

        this.$toast.success(this.$t('general.shared.savedChanges'));

        this.$emit('emitReloadResource');
        this.$emit('closed');

        this.media = [];

        const { uploader }: any = this.$refs;

        if (!!uploader) {
          uploader.mediaLibrary.state.media = [];
        }
      } catch (e: any) {
        console.error(e);

        this.$toast.error(e.response.data.message);
      }
    },
  },
});
</script>
